import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Form, Button, Divider } from 'antd';
import { CreateEditTrainingProjectFormValues } from '../../types';
import {
    TrainingProjectNameInput,
    TrainingProjectModelsSettings,
    TrainingProjectTaskTypeSelect,
    TrainingProjectOptimizerTypeSelect,
    TrainingProjectOptimizerParamsInput,
    TrainingProjectJsonSchemas,
    TrainingProjectFieldDescriptions,
    TrainingProjectModuleTypeSelect,
    TrainingProjectAdapterTypeSelect
} from '..';
import { TrainingProjectsStore } from '../../stores';
import './CreateEditTrainingProjectModal.less';

interface Props {
    store: TrainingProjectsStore;
}

const CreateEditTrainingProjectModal: React.FC<Props> = ({ store }) => {
    const [form] = Form.useForm<CreateEditTrainingProjectFormValues>();

    const onFinish = async (formValues: CreateEditTrainingProjectFormValues) => {
        const completed = store.editableTrainingProject
            ? await store.editableTrainingProject.update(formValues)
            : await store.createTrainingProject(formValues);

        if (completed) {
            onClose();
        }
    };

    const onClose = () => {
        store.setCreateEditDialogVisible(false);
        store.editableTrainingProject?.setEditable(false);
    };

    React.useEffect(() => {
        if (store.project) {
            store.loadMlModels();
        }
    }, [store, store.project]);

    return (
        <Modal
            className="create-edit-training-project-dialog"
            title={store.editableTrainingProject ? 'Update Training Project' : 'Create Training Project'}
            visible={store.createEditDialogVisible}
            width={800}
            onCancel={onClose}
            maskClosable={false}
            closable={false}
            destroyOnClose
            centered
            footer={[
                <Button
                    form="create-edit-training-project-form"
                    data-id="create-edit-training-project-cancel"
                    key="create-edit-training-project-cancel"
                    className="light"
                    size="large"
                    onClick={onClose}
                >
                    Cancel
                </Button>,
                <Button
                    form="create-edit-training-project-form"
                    data-id="create-training-project"
                    key="create-training-project"
                    size="large"
                    type="primary"
                    htmlType="submit"
                >
                    {store.editableTrainingProject ? 'Update' : 'Create'}
                </Button>
            ]}
        >
            <Form
                id="create-edit-training-project-form"
                layout="vertical"
                form={form}
                onFinish={onFinish}
                preserve={false}
            >
                <TrainingProjectNameInput store={store} />
                <Divider />
                <TrainingProjectTaskTypeSelect store={store} />
                <Divider />
                <TrainingProjectModelsSettings store={store} />
                <Divider />
                <TrainingProjectAdapterTypeSelect store={store} />
                <Divider />
                <TrainingProjectModuleTypeSelect store={store} />
                <Divider />
                <TrainingProjectOptimizerTypeSelect store={store} />
                <Divider />
                <TrainingProjectOptimizerParamsInput store={store} />
                <Divider />
                <TrainingProjectJsonSchemas store={store} />
                <Divider />
                <TrainingProjectFieldDescriptions store={store} />
            </Form>
        </Modal>
    );
};

export default observer(CreateEditTrainingProjectModal);
